export const APPROVAL_REQUEST_ANALYTICS_EVENTS = {
  APPROVAL_REQUEST_LIST_FETCH: "approval-request-list-fetch",
  APPROVAL_REQUEST_DETAIL_FETCH: "approval-request-detail-fetch",
  APPROVAL_REQUEST_ACTION: "approval-request-action",
  APPROVAL_REQUEST_OVERRIDE: "approval-request-override",
  APPROVAL_REQUEST_CANCEL: "approval-request-cancel",
};
